import {createAsyncThunk} from "@reduxjs/toolkit";
import axios from "store/axios";
import {
  loadDashboardMenuItemsSuccess,
  loadUserDataSuccess,
  saveEmail,
  saveMessEmail,
  saveMessOTP,
  signoutUserSuccess,
} from "./authSlice";
import {NavItem} from "./types";

export const getProgram = async (query: string) => {
  try {
    return await axios.get("/hr/v1/programs/" + query);
  } catch (error: any) {
    if (error.response && error.response.data) {
      return error.response.data;
    }
    return {
      error: "There is an exception error !",
    };
  }
};

//API send Email
export const sendEmailAction = createAsyncThunk(
  "auth/sendEmail",
  async (useremail: string, { dispatch }) => {
    try {
      const response = await sendEmail(useremail);
      if (response.data?.data) {
        dispatch(saveEmail(useremail));
      } else {
        dispatch(saveMessEmail(response.message));
      }
      return response;
    } catch (error) {
      // Ignore and let caller handle an undefined response.
    }
  }
);
export const sendEmail = async (email: string) => {
  try {
    return await axios.post("/hr/v1/users/email_exists", {email});
  } catch (error: any) {
    if (error.response && error.response.data) {
      return error.response.data;
    }
    return {
      error: "There is an exception error !",
    };
  }
};

export const doExportPdf = async (data: any) => {
  try {
    return await axios.post("/hr/v1/export_pdf", {data});
  } catch (error: any) {
    if (error.response && error.response.data) {
      return error.response.data;
    }
    return {
      error: "There is an exception error !",
    };
  }
};

//API send OTP
export const sendOTPAction = createAsyncThunk(
  "auth/sendOTP",
  async (
    params: { otp: string; useremail: string; history: any },
    { dispatch, getState }
  ) => {
    const { auth } = getState() as { auth: any };
    try {
      const { otp, useremail, history } = params || {};
      const res = await sendOTP(otp, useremail);
      if (res && res.data) {
        const token = res.data.data.token;
        localStorage.setItem("token", token);
        dispatch(fetchDashboardMenuItems());
        dispatch(fetchUserData(history, auth.programId));
      } else {
        dispatch(
          saveMessOTP(
            res?.errors[0] ||
            "Your OTP is invalid or expired, please try again!"
          )
        );
      }
      return res;
    } catch (error) {
      // Ignore and let caller handle an undefined response.
    }
  }
);
export const sendOTP = async (otp: string, email: string) => {
  try {
    return await axios.post("/hr/v1/users/otp", {otp, email});
  } catch (error: any) {
    if (error.response && error.response.data) {
      return error.response.data;
    }
    return {
      error: "There is an exception error !",
    };
  }
};

//API fetch user data
export const fetchUserData = (history: any, programId: string) => {
  return async (dispatch: any, getState: any) => {
    try {
      const res = await getProgram(programId);
      const { auth } = getState() as { auth: any };
      const overviewMenu = auth?.dashboard_menu_items[0];
      if (res && res.data) {
        const datas = res.data.data;
        const recommendations = datas.recommendations.map((item: any) => {
          return {
            title: Object.keys(item)[0],
            data: item[Object.keys(item)[0]],
          };
        });
        const userData = { ...datas, recommendations };
        dispatch(loadUserDataSuccess(userData));
        
        if (
          history.location.pathname === "/signin" ||
          history.location.pathname === "/token"
        ) {
          let is_aia_cs: any = new URLSearchParams(history.location.search).get('is_aia_cs') == "true" || userData?.user?.role == "AIACS"
          if (is_aia_cs) {
            history.push({
              pathname: "tf-aia-cs",
              search: history.location.search,
            });
          } else {
            const redirectPath = overviewMenu?.slug || "overview"; // fallback to "overview" if slug is undefined
            history.push({
              pathname: redirectPath,
              search: history.location.search,
              state: { menu_item: overviewMenu },
            });
          }
         
        }
      } else {
        localStorage.removeItem("token");
        dispatch(signoutUserSuccess());
      }
    } catch (error: any) {
      if (error?.response?.status === 401) {
        localStorage.removeItem("token");
        dispatch(signoutUserSuccess());
      }
    }
  };
};

//API token
export const genTokenAction = (
  token: string,
  history: any,
  programId: string
) => {
  return async (dispatch: any) => {
    const res = await getToken(token);
    if (res && res.data) {
      // Extract data from the correct nested structure: res.data.data.*
      const responseData = res.data.data;
      const authToken = responseData.token;
      const uid = responseData.uid;
      const enableCreditSystem = responseData.enable_credit_system;

      // Save comprehensive user and organization data from the response
      const userData = {
        uid: uid,
        email: null, // Not in this response structure
        user_type: null, // Not in this response structure
        organization_name: responseData.organization_name,
        organization_code: responseData.organization_code,
        policy_end_date: responseData.policy_end_date,
        launch_date: responseData.launch_date,
        termination_date: responseData.termination_date,
        enable_credit_system: enableCreditSystem
      };

      localStorage.setItem("user_data", JSON.stringify(userData));
      localStorage.setItem("uid", uid);
      localStorage.setItem("enable_credit_system", String(enableCreditSystem));

      localStorage.setItem("token", authToken);
      // Wait for dashboard menu items to load first
      await dispatch(fetchDashboardMenuItems());
      // Then fetch user data and redirect
      dispatch(fetchUserData(history, programId));
    }
  };
};
export const getToken = async (uid: string) => {
  try {
    return await axios.get(`/hr/v1/users/${uid}/admin_token`);
  } catch (error: any) {
    if (error.response && error.response.data) {
      return error.response.data;
    }
    return {
      error: "There is an exception error !",
    };
  }
};

export const getSuperSetGuestToken = async ({resourceId, orgId, resourceType = 'dashboard'}: { resourceId: string, orgId: number, resourceType: string }) => {
  try {
    return await axios.get("/hr/v1/superset/guest_token", {
      params: {
        resource_id: resourceId,
        org_id: orgId,
        resource_type: resourceType,
      },
    });
  } catch (error: any) {
    if (error.response && error.response.data) {
      return error.response.data;
    }
    return {
      error: "There is an exception error !",
    };
  }
};

export const fetchDashboardMenuItems = () => {
  return async (dispatch: any, getState: any) => {
    try {
      const res = await axios.get(`hr/v1/tfi_dashboards`);
      if (res && res.data) {
        // sort by order
          const sortedItems = res.data.data.sort((a: any, b: any) => {
              return a.order - b.order;
          });
          const menuItems = sortedItems.map((item: NavItem) => {
              return {
                id: item.id,
                name: item.name,
                slug: item.slug,
                order: item.order,
                dashboard_id: item.dashboard_id,
                show_filter: item.show_filter,
                is_navigable: item.is_navigable,
                sub_dashboards: item.sub_dashboards,
              };
          });

          // dispatch the menu items to the store
          dispatch(loadDashboardMenuItemsSuccess(menuItems));
      }
    } catch (error: any) {
      if (error?.response?.status === 401) {
        localStorage.removeItem("token");
        dispatch(signoutUserSuccess());
      }
    }
  }
}